import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Custom hook to handle authentication redirects and session restoration
 */
export const useAuthRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Function to redirect to login with returnUrl
  const redirectToLogin = (returnUrl?: string) => {
    const redirectPath = `/login${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ''}`;
    navigate(redirectPath, { replace: true });
  };
  
  // Function to redirect after login
  const redirectAfterLogin = () => {
    // Check if there's a return URL in the query params
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl');
    
    if (returnUrl) {
      // Navigate to the return URL if it exists
      navigate(decodeURIComponent(returnUrl), { replace: true });
    } else {
      // Otherwise, navigate to the account page
      navigate('/account', { replace: true });
    }
  };
  
  // Function to redirect after sign up
  const redirectAfterSignUp = () => {
    navigate('/account', { replace: true });
  };
  
  // Function to redirect if authenticated (for PublicOnlyRoute)
  const redirectIfAuthenticated = () => {
    navigate('/account', { replace: true });
  };
  
  // Legacy stub — subscription checkout verification removed.
  // Credit purchases are verified in CreditsTab via verify-credit-purchase.
  const restoreSessionFromUrl = async () => {
    return false;
  };
  
  return {
    redirectToLogin,
    redirectAfterLogin,
    redirectAfterSignUp,
    redirectIfAuthenticated,
    restoreSessionFromUrl,
    isReady: true,
  };
};
